module.exports = __webpack_public_path__ + "media/images/powerpoint/bva-background-3a1b8ae3094e9e33ff2b76d1f79c4586.png";